import React from 'react';
import {useToast} from "@/components/ui/use-toast";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger
} from "@/components/ui/dropdown-menu";
import {Button} from "@/components/ui/button";
import {IconBrandFacebook, IconBrandX, IconLink, IconMail, IconShare2} from "@tabler/icons-react";
import Link from "next/link";
import {DrupalNode} from "next-drupal";

const host = process.env.NEXT_PUBLIC_URL;

const SocialShare = ({node, txtButton = true, ...props}: { node: DrupalNode, txtButton?: boolean }) => {
  const currentUrl = host?.replace(/\/$/, '') + '/' + node.path.alias.replace(/^\//, '')
  const {toast} = useToast()

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(currentUrl)
      toast({description: "Le lien a été copié"})
    } catch (err) {
      console.error(err)
    }
  }

  const linkArticle = process.env.NEXT_PUBLIC_URL + node.path.alias
  let mailToSubject = ""
  let mailToBody = ""

  if (node.type === "node--article" || node.type === "node--article_archive") {
    mailToSubject = node.title + " - Article RRB"

    /* Est identique à node.metatag[1].attributes.content  */
    mailToBody = node.field_sous_titre + "%0D%0A%0D%0AVoir l'article complet sur le site RRB : " + linkArticle
  }
  if (node.type === "node--podcast") {
    mailToSubject = node.title + " - Podcast RRB"
    mailToBody = node.metatag[1].attributes.content + "%0D%0A%0D%0AÉcouter le podcast complet sur le site RRB : " + linkArticle
  }
  if (node.type === "node--emission") {
    mailToSubject = node.title + " - Émission RRB"
    mailToBody = node.metatag[1].attributes.content + "%0D%0A%0D%0ARegarder l'émission sur le site RRB : " + linkArticle
  }
  if (node.type === "node--avis") {
    mailToSubject = node.title + " - Avis RRB"
    mailToBody = node.metatag[1].attributes.content + "%0D%0A%0D%0AVoir l'avis sur le site RRB : " + linkArticle
  }

  // Contenu de l'e-mail
  const mailTo = "mailto:" + "?subject=" + mailToSubject + "&body=" + mailToBody

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button className="w-full md:w-fit" variant='tertiary'
                iconLeft={<IconShare2 size='20'/>}>{txtButton ? 'Partager' : ''}</Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuLabel>Partager ce contenu</DropdownMenuLabel>
        <DropdownMenuItem asChild className="justify-start">
          <Link href={`https://www.facebook.com/sharer/sharer.php?u=${currentUrl}`} target="_blank"
                className="cursor-pointer">
            <IconBrandFacebook size={18} className="mr-2"/>
            Partager sur Facebook
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild className="justify-start">
          <Link href={`https://twitter.com/share?url=${currentUrl}`} target="_blank" className="cursor-pointer">
            <IconBrandX size={18} className="mr-2"/>
            Partager sur X
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild className="justify-start">
          <span onClick={copyToClipboard} className="cursor-pointer">
              <IconLink size={18} className="mr-2"/>
              Copier le lien
          </span>
        </DropdownMenuItem>
        {/* Pour afficher uniquement l'option d'envoi par mail sur les contenus voulu */}
        {(node.type === "node--article" || node.type === "node--article_archive" || node.type === "node--podcast" || node.type === "node--emission" || node.type === "node--avis") && (
          <DropdownMenuItem asChild className="justify-start">
            <Link href={mailTo} className="cursor-pointer" target="_blank" rel="noopener noreferrer">
              <IconMail size={18} className="mr-2"/>
              Partager par courriel
            </Link>
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default SocialShare;
